const STORE_URL_REGEX =
  /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z]{2,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;

export function isValidStoreUrl(input: string): boolean {
  const normalized = normalizeStoreUrl(input);
  if (!normalized) {
    return false;
  }

  return STORE_URL_REGEX.test(normalized);
}

export function normalizeStoreUrl(input: string): string {
  let url = input.trim();
  if (!url) {
    return "";
  }
  if (!/^https?:\/\//i.test(url)) {
    url = `https://${url}`;
  }
  return url.replace(/\/+$/, "");
}
